import { getAuth } from "firebase/auth";
import Form from "react-bootstrap/Form";
import { useEffect, useMemo, useState } from "react";
import Button from "react-bootstrap/Button";
import FloatingLabel from "react-bootstrap/FloatingLabel";
import { useAuthState } from "react-firebase-hooks/auth";
import Card from "react-bootstrap/Card";
import { FirebaseError } from "firebase/app";
import firebaseErrors from "../../modules/firebaseErrors";
import Spinner from "react-bootstrap/Spinner";
import { useDocumentData } from "react-firebase-hooks/firestore";
import { doc, getFirestore, setDoc } from "firebase/firestore";
import { getFirestoreZodConverter } from "../../modules/firestoreZodConverter";
import { UserDocumentData, userDocumentSchema } from "../../types/firestore";
import { shallowEqualObjects } from "shallow-equal";

const auth = getAuth();
const firestore = getFirestore();

export default function Manage() {
	const [saving, setSaving] = useState(false);
	const [error, setError] = useState<string>();
	const [success, setSuccess] = useState(false);

	const [user] = useAuthState(auth);

	const userDocumentRef = useMemo(
		() =>
			user &&
			doc(firestore, "Users", user.uid).withConverter(getFirestoreZodConverter(userDocumentSchema)),
		[user],
	);

	const [userDocument] = useDocumentData(userDocumentRef);

	useEffect(() => {
		if (userDocument) setUserData(userDocument);
		else setUserData(undefined);
	}, [userDocument]);

	const [userData, setUserData] = useState<UserDocumentData>();

	if (!user) return <div></div>;

	return (
		<Card className="mb-2">
			<Card.Header className="mb-2 fw-bold">Mein Profil</Card.Header>

			<Card.Body>
				{userData && (
					<div>
						<div className="mb-2">Email: {user.email}</div>

						<FloatingLabel label="Vorname" className="mb-2">
							<Form.Control
								placeholder="Vorname"
								value={userData.FirstName}
								onChange={(e) => setUserData({ ...userData, FirstName: e.target.value })}
							/>
						</FloatingLabel>

						<FloatingLabel label="Nachname" className="mb-2">
							<Form.Control
								placeholder="Nachname"
								value={userData.LastName}
								onChange={(e) => setUserData({ ...userData, LastName: e.target.value })}
							/>
						</FloatingLabel>
					</div>
				)}

				{error && <div className="mb-2 text-danger">{error}</div>}

				{success && (
					<div className="mb-2 text-success">Das Profil wurde erfolgreich gespeichert.</div>
				)}

				<Button
					disabled={saving || shallowEqualObjects(userData, userDocument)}
					variant="success"
					onClick={async () => {
						if (!userData) return;
						if (!userDocumentRef) return;

						setSaving(true);
						setError(undefined);
						setSuccess(false);

						try {
							await setDoc(userDocumentRef, userData);

							setSaving(false);
							setSuccess(true);
						} catch (error) {
							if (error instanceof FirebaseError) {
								setSaving(false);

								const message = firebaseErrors[error.code] ?? error.message;

								setError(message);
								return;
							}

							throw error;
						}
					}}>
					{saving && <Spinner className="me-1" animation="border" size="sm" />}
					Speichern
				</Button>
			</Card.Body>
		</Card>
	);
}
